import { DiscountVoucher } from '../models'
import { getTransformedDate } from '../helpers'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomText,
  CustomHeaderText,
  DiscountVoucherMovileViewColumn,
  DiscountVoucherEmailColumn,
} from 'src/components'

const discountVoucherColumns: ColumnsType<DiscountVoucher> = [

  {
    title: () => <CustomHeaderText text='card.Code' />,
    responsive: ['sm'],
    sorter: (a: DiscountVoucher, b: DiscountVoucher) => a.code.length - b.code.length,
    render: (_, discountVoucher) => <CustomText label={discountVoucher.code} strong />
  },

  {
    title: () => <CustomHeaderText text='Discount.Percentage' isCentered />,
    responsive: ['sm'],
    sorter: (a: DiscountVoucher, b: DiscountVoucher) => a.percentage - b.percentage,
    render: (_, discountVoucher) => (
      <CustomText
        label={`${discountVoucher.percentage} %`}
        className='centered'
        mark
      />
    )
  },

  {
    title: () => <CustomHeaderText text='Summary.Email' isCentered />,
    responsive: ['sm'],
    sorter: (a: DiscountVoucher, b: DiscountVoucher) => a.email?.length - b.email?.length,
    render: (_, discountVoucher) => <DiscountVoucherEmailColumn discount={discountVoucher} />
  },

  {
    title: () => <CustomHeaderText text='ValidateDeposits.DateCreated' isCentered />,
    responsive: ['sm'],
    sorter: (a: DiscountVoucher, b: DiscountVoucher) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, discountVoucher) => <CustomText label={getTransformedDate(discountVoucher.created)} />
  },

  {
    title: () => <CustomHeaderText text='SalesOffer.ExpirationDate' isCentered />,
    responsive: ['sm'],
    sorter: (a: DiscountVoucher, b: DiscountVoucher) => {
      const dateA = new Date(a.expiration_date)
      const dateB = new Date(b.expiration_date)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, discountVoucher) => (
      <CustomText
        label={getTransformedDate(discountVoucher.expiration_date)}
        className='centered'
      />
    )
  },

  // Mobile View
  {
    title: () => <CustomHeaderText text='Vouchers.Title2' />,
    responsive: ['xs'],
    sorter: (a: DiscountVoucher, b: DiscountVoucher) => {
      const dateA = new Date(a.created)
      const dateB = new Date(b.created)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, discountVoucher) => <DiscountVoucherMovileViewColumn discountVoucher={discountVoucher} />
  },
]

export default discountVoucherColumns
